import React, { Children } from 'react';
import { compose, withState, withHandlers, lifecycle } from 'recompose';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { withHideOnEmpty } from 'decorators';
import { Button } from 'components/core/Button';

import './Tabs.scss';

export const enhance = compose(
	withState('activeTab', 'setActiveTab', 0),
	withHandlers({
		selectTab: (props) => (index) => () => {
			if (props.children[index] && props.children[index].props.onSelect) {
				props.children[index].props.onSelect(true);
			}
			props.setActiveTab(index);
		},
	}),
	lifecycle({
		componentDidUpdate() {
			if (
				!this.props.children[this.props.activeTab] &&
				this.props.activeTab !== 0
			) {
				this.props.setActiveTab(0);
			}
		},
	}),
	withHideOnEmpty,
);

export function Tabs({ activeTab, children, className, selectTab }) {
	return (
		<div className={classnames('tabs-container', className)}>
			<ul
				className="nav nav-tabs"
				role="tablist"
			>
				{Children.toArray(children).map((child, index) => (
					<li
						className={classnames('nav-item', {
							active: activeTab === index,
							[child.props.className]: child.props.className,
						})}
						key={child.key}
						role="tab"
					>
						<Button
							className="nav-button"
							onClick={selectTab(index)}
						>
							{child.props.title}
						</Button>
					</li>
				))}
			</ul>
			<div className="tab-content">
				{Children.toArray(children).map((child, index) =>
					React.cloneElement(child, { active: activeTab === index }),
				)}
			</div>
		</div>
	);
}

Tabs.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	activeTab: PropTypes.number,
	selectTab: PropTypes.func.isRequired,
};

Tabs.defaultProps = {
	activeTab: 0,
};

export default enhance(Tabs);
